import Grid from '@material-ui/core/Grid';
import { Avatar, createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';
import { blueGrey, grey } from '@material-ui/core/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(0),
      margin: theme.spacing(1),
    },
    avatar: {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.text.secondary,
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.getContrastText(blueGrey[500]),
      },
    },
    activeAvatar: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.getContrastText(grey[900]),
    },
    small: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    large: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
  }),
);

interface ILeaderIconProps {
  displayName: string;
  avatarImg: string;
  size?: 'small' | 'large';
  isSelected?: Boolean;
}

export default function LeaderIcon(props: ILeaderIconProps) {
  const { displayName, avatarImg, size = 'medium', isSelected = false } = props;
  const classes = useStyles(baseTheme);

  const classSize = size === 'large'
    ? classes.large
    : size === 'small'
      ? classes.small
      : null;

  const isActive = isSelected
    ? classes.activeAvatar
    : null;

  return (
    <Grid className={classes.root}>
      <Avatar
        alt={displayName}
        src={avatarImg}
        className={`${classSize} ${classes.avatar} ${isActive}`}
      />
    </Grid>
  );
}
